import { FileReader, FileWriter } from '@/platform'

class Str {
    public Name: string
    public Value: string
    ToString() {
        return this.Name
    }

    constructor(v: string = '', s: string = '') {
        this.Name = s
        this.Value = v
    }

    readBin(reader: FileReader): void {
        this.Name = reader.readString()
        this.Value = reader.readString()
    }

    writeBin(writer: FileWriter): void {
        writer.writeString(this.Name)
        writer.writeString(this.Value)
    }

    readVersionedOui(reader: FileReader): void {
        this.Name = reader.readString()
        this.Value = reader.readString()
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeString(this.Name)
        writer.writeString(this.Value)

        writer.writerLength()
    }
}
export default Str
